module.exports = __webpack_public_path__ + "static/media/8OLA26.57d471f8.jpg";